<template>
  <div class="left">
    <div>
      <h3 class="font-bold text-2xl leading-9">
        <WrGradientText
          :text="data?.heading"
          append-class="pb-0 md:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
        />
      </h3>
      <p class="leading-[1.6] mt-4">{ {{ data?.subheading }}}</p>
      <!-- CTA -->
      <WrButton
        container-class="mt-2 md:mt-6"
        append-class="flex items-center gap-2"
        @click="sendReceipt"
      >
        Let's work together
      </WrButton>
    </div>
  </div>
  <div class="grid grid-col-1 md:grid-cols-2 md:gap-6">
    <div
      v-for="reason in data?.reasons"
      class="mt-4 lg:mt-0 middle p-4 rounded-lg hover:shadow-[0_0_8px_rgba(0,0,0,0.3)] transition-all duration-300 ease-in-out bg-white dark:bg-transparent dark:hover:[box-shadow:0_0_10px_2px_rgba(98,69,116,0.7)] dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)]"
    >
      <span
        class="bg-[#ffdddb] flex items-center justify-center w-[60px] h-[60px]"
      >
        <NuxtImg
          :src="reason.image"
          width="40"
          height="40"
          alt="Example"
          loading="lazy"
           format="webp"
        />
      </span>
      <h3 class="pt-4 font-bold text-lg md:text-xl">{{ reason.title }}</h3>
      <p class="leading-[1.8] mt-4">
        {{ reason.text }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
type Reason = {
  image: string;
  title: string;
  text: string;
};

type BuildTeamData = {
  heading: string;
  subheading: string;
  linkText: string;
  reasons: Reason[];
};

const props = defineProps<{
  data: BuildTeamData;
}>();

const emit = defineEmits<{
  (e: "openModal"): void;
}>();

function sendReceipt() {
  emit("openModal");
}
</script>
